<script setup lang="ts">
interface ButtonTertiaryProps {
  label: string
  alignX?: 'left' | 'right' | undefined
  disabled?: boolean | undefined
  hideLabelOnSmallScreens?: boolean | undefined
}

const props = defineProps<ButtonTertiaryProps>()

const slots = defineSlots<{
  default: string
}>()
</script>

<template>
  <button
    class="flex items-center gap-1 whitespace-nowrap text-sm text-black-400"
    :class="[
      // Alignment
      props.alignX === 'left'
        ? 'justify-start text-left'
        : props.alignX === 'right'
          ? 'justify-end text-right'
          : 'justify-center text-center', // default = center

      // Disabled / Hover
      props.disabled
        ? 'text-black-200 hover:cursor-not-allowed'
        : 'hover:cursor-pointer hover:text-lochmara-600',
    ]"
    :disabled="props.disabled"
    type="button"
  >
    <div v-if="slots.default" class="h-6 w-6">
      <slot></slot>
    </div>
    <span :class="props.hideLabelOnSmallScreens ? 'hidden lg:inline' : ''">{{ props.label }}</span>
  </button>
</template>
